import React, { FC } from "react";
import { Accordion } from "./Accordion";
import { ItemCustomizationsProps } from "../common/types";

// currently only need to support description, number, text
// will need to be refactored once we know future customizations
export const ItemCustomizations: FC<ItemCustomizationsProps> = ({
  customizations,
}) => {
  const customizationsList = (customizations || []).map((item, i) => {
    const { description, number, text } = item;
    const personalizationText =
      !!number && !!text ? `${text}, ${number}` : `${text || number || ""}`;
    return (
      <div key={i}>
        {!!description && <div>ID Ring: {description}</div>}
        {!!personalizationText && (
          <div>Personalization: {personalizationText}</div>
        )}
      </div>
    );
  });

  return customizationsList.length > 0 ? (
    <Accordion title="Customizations" list={customizationsList} />
  ) : (
    <></>
  );
};
